import { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { trackEvent } from '../lib/analytics';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const EMPTY_CONTACT_FORM = { name: '', email: '', phone: '', service: '', message: '' };

const isValid = (data) => Boolean(data.name && data.email && data.phone && data.service);

const useContactForm = () => {
  const [formData, setFormData] = useState(EMPTY_CONTACT_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleChange = (e) => setField(e.target.name, e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid(formData)) {
      toast.error('Missing Required Fields', {
        description: 'Please fill in all required fields (Name, Email, Phone, Service)',
      });
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/inquiries`, formData);
      if (response.data.success) {
        trackEvent('form_submission', {
          event_category: 'Contact',
          event_label: formData.service || 'General Inquiry',
          value: 1,
        });
        toast.success('Inquiry Submitted Successfully!', { description: response.data.message });
        setFormData(EMPTY_CONTACT_FORM);
      }
    } catch (error) {
      trackEvent('form_error', { event_category: 'Contact', event_label: 'Submission Failed' });
      toast.error('Submission Failed', {
        description: error.response?.data?.detail || 'Please try again or contact us directly.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, setField, handleChange, handleSubmit };
};

export default useContactForm;
